<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.4 7.5h.2m.4 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM3 6v4.757a3 3 0 0 0 .879 2.122l7.25 7.25a3 3 0 0 0 4.242 0l4.758-4.758a3 3 0 0 0 0-4.242l-7.25-7.25A3 3 0 0 0 10.757 3H6a3 3 0 0 0-3 3Z"
      stroke="currentColor"
    stroke-linecap="square"
    stroke-width="2"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
